module.exports = __webpack_public_path__ + "img/mic-mute-fill.07b34e2c.svg";